import { render, staticRenderFns } from "./TaxFilings.vue?vue&type=template&id=e7c21e60&scoped=true&"
import script from "./TaxFilings.vue?vue&type=script&lang=js&"
export * from "./TaxFilings.vue?vue&type=script&lang=js&"
import style0 from "./TaxFilings.vue?vue&type=style&index=0&id=e7c21e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c21e60",
  null
  
)

export default component.exports